import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NachStatus, NachRepayment, Loan, Application, MambuLoan, RazorpayPaymentStatus } from './loans';
import { BackendService } from '../backend.service';
import { TokenService } from 'app/token/token.service';

@Injectable()
export class LoanService {

  private nachStatusUrl = '/nach/nachRegistrationStatuses/{{LoanId}}';
  private nachRepaymentsUrl = '/Repayments/Loans/{{LoanId}}/BilldeskPayments';
  private loanUrl = '/Loan/Loans/{{LoanId}}?includeRepayments=true';
  private loanApplicationDetailsUrl = '/ApplicationFlow/LoanApplications/{{applicationId}}';
  private loansUrl = '/Loan/Customer/{customerId}/Loans?includeMerchantSettings=true&includeRepayments=true&merId={{merchantId}}';
  private ongoingLoansUrl = '/Loan/Customer/{customerId}/Loans?Status=Active&Status=InArrears&includeMerchantSettings=true&includeRepayments=true&merId={{merchantId}}';
  private pastLoansUrl = '/Loan/Customer/{customerId}/Loans?Status=PaidOff&Status=Cancelled&includeMerchantSettings=true&includeRepayments=true&merId={{merchantId}}';
  private mambuLoanUrl = '/ZestMambu/Loans/{{LoanId}}/Association';
  private razorpayGetStatusUrl = '/Razorpay/LoanApplication/{{LoanId}}/Payments';
  private smsTriggerUrl = '/SMSGateway/sms/template';
  public merchantId: string;
  private getBoltOutstandingAmountUrl = '/revolving-credit/api/v1/customers/{customerId}/loan';
  private getBoltBillsURL = '/revolving-credit/api/v1/customers/{customerId}/bills?latest=true&limit=2&withTransactions=true';
  private getBoltSwitchUrl = '/switch/bolt_switch.json';

  constructor(private backendService: BackendService, private tokenService: TokenService) {
    this.merchantId = this.tokenService.getMerchantConfig() ? this.tokenService.getMerchantConfig().merchantId : '';
  }

  getNachStatus(loanId: string): Observable<NachStatus> {
    return this.backendService.getData(this.nachStatusUrl.replace('{{LoanId}}', loanId), null, false);
  }
  getNachRepayment(loanId: string): Observable<NachRepayment> {
    return this.backendService.getData(this.nachRepaymentsUrl.replace('{{LoanId}}', loanId), null, false);
  }

  getLoan(loanId: string): Observable<Loan> {
    return this.backendService.getData(this.loanUrl.replace('{{LoanId}}', loanId), null, false);
  }
  getLoanApplicationDetails(applicationId: string): Observable<Application> {
    return this.backendService.getData(this.loanApplicationDetailsUrl.replace('{{applicationId}}', applicationId), null, false, false);
  }
  getLoans(): Observable<Loan[]> {
    return this.backendService.getData(this.loansUrl.replace('{{merchantId}}', this.merchantId), null, false);
  }
  getOnGoingLoans(): Observable<Loan[]> {
    return this.backendService.getData(this.ongoingLoansUrl.replace('{{merchantId}}', this.merchantId), null, false);
  }
  getPastLoans(): Observable<Loan[]> {
    return this.backendService.getData(this.pastLoansUrl.replace('{{merchantId}}', this.merchantId), null, false);
  }
  getMambuLoan(loanId: string): Observable<MambuLoan> {
    return this.backendService.getData(this.mambuLoanUrl.replace('{{LoanId}}', loanId), null, false);
  }
  getPaymentStatus(loanId: string): Observable<RazorpayPaymentStatus> {
    return this.backendService.getData(this.razorpayGetStatusUrl.replace('{{LoanId}}', loanId), null, false);
  }
  getBoltOutstandingAmount() {
    return this.backendService.getData(this.getBoltOutstandingAmountUrl.replace('{customerId}', this.tokenService.getCustomerId()));
  }
  getBoltBills() {
    return this.backendService.getData(this.getBoltBillsURL.replace('{customerId}', this.tokenService.getCustomerId()));
  }
  getBoltBannerSwitch() {
    return this.backendService.getData(this.getBoltSwitchUrl, null, false, false, true);
  }
  triggerSMSForPayment(): Observable<any> {
    const data = {
      'CustomerID': this.tokenService.getCustomerId(),
      'TemplateId': 'ETMoneyCashCredit'
    };
    return this.backendService.setData(this.smsTriggerUrl, data);
  }
}
